/* ─────────────────────────────────────────────────────────────
   SITE CONFIG — Single source of truth for site-wide text.
   Update these values here and they'll change everywhere.
   ───────────────────────────────────────────────────────────── */

export const siteConfig = {
  name: 'RankTT',
  tagline: 'The global standard for table tennis ratings',
  description:
    'Track your ELO rating, compete with your club, and rise through the ranks. Built for everyone — from office players to serious competitors.',
  // Displayed under sign-up CTAs across the marketing site.
  // Update this number once real user data is available.
  socialProof: 'Join 1,200+ players already tracking their rating',
  copyright: '© 2025 RankTT. All rights reserved.',
  contactEmail: 'hello@ranktt.com',
};
